module.exports = __webpack_public_path__ + "static/media/41-12.c4633918.mp3";